import React, { useEffect, useState } from "react";
import Aos from "aos";
import Landing from "./content/Landing";
import AboutClinic from "./content/AboutClinic";
import AboutDR from "./content/AboutDR";
import Certificates from "./content/Certificates";
import Directions from "./content/Directions";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const Home = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);
  const navigate = useNavigate();
  const isAuth = useSelector((state) => state.main.isAuthenticated);
  useEffect(() => {
    if (!isAuth) {
      navigate("/login");
    }
  }, [isAuth]);
  return (
    <>
      <section className="home-admin">
        <Landing />
        <AboutClinic />
        <AboutDR />
        <Certificates />
        <Directions />
      </section>
    </>
  );
};

export default Home;
